import Vue from 'vue';
import VueRouter from 'vue-router';

import { Dialog } from 'quasar';
import { i18n } from 'boot/i18n';
import routes from './routes';

Vue.use(VueRouter);

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default function (/* { store, ssrContext } */) {
  const router = new VueRouter({
    scrollBehavior: () => ({
      x: 0,
      y: 0,
    }),
    routes,

    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE,
  });

  // Force the app to reload on chunk failed error
  router.onError((error) => {
    if (/loading chunk \d* failed./i.test(error.message)) {
      Dialog.create({
        title: i18n.t('serviceWorker.event.updated.title'),
        message: i18n.t('serviceWorker.event.updated.message'),
        ok: i18n.t('serviceWorker.event.updated.ok'),
        persistent: true,
      }).onOk(() => {
        document.location.reload(true);
      });
    }
  });

  return router;
}
